export const passwordLengthIsValid = (password) => password.length >= 8;
